import { createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f972560"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  class: "divider",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_3 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["zoom-wrapper", { landscape: $props.landscape }])
  }, [
    _createCommentVNode(" 확대 버튼 "),
    _createElementVNode("button", {
      class: "zoom-in",
      type: "button",
      onClick: $setup.zoomIn,
      disabled: $setup.currentZoom >= $setup.maxZoom,
      "aria-label": "확대"
    }, [
      _createVNode($setup["InlineSvg"], {
        class: _normalizeClass(["icon", { disabled: $setup.currentZoom >= $setup.maxZoom }]),
        src: require('@/assets/icons/plus.svg'),
        "aria-hidden": "true"
      }, null, 8 /* PROPS */, ["class", "src"])
    ], 8 /* PROPS */, _hoisted_1),
    _hoisted_2,
    _createCommentVNode(" 축소 버튼 "),
    _createElementVNode("button", {
      class: "zoom-out",
      type: "button",
      onClick: $setup.zoomOut,
      disabled: $setup.currentZoom <= $setup.minZoom,
      "aria-label": "축소"
    }, [
      _createVNode($setup["InlineSvg"], {
        class: _normalizeClass(["icon", { disabled: $setup.currentZoom <= $setup.minZoom }]),
        src: require('@/assets/icons/minus.svg'),
        "aria-hidden": "true"
      }, null, 8 /* PROPS */, ["class", "src"])
    ], 8 /* PROPS */, _hoisted_3)
  ], 2 /* CLASS */))
}